import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  equalsLowerCase1477z9rxwgcv2 as equalsLowerCase,
  hashCodeLowerCase2r6jfpu8gi2u9 as hashCodeLowerCase,
} from './internals/Chars.mjs';
import { abs1kdzbjes1idip as abs } from '../../../../../kotlin-kotlin-stdlib/kotlin/math/math.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { sequence2vgswtrxvqoa7 as sequence } from '../../../../../kotlin-kotlin-stdlib/kotlin/sequences/SequenceBuilder.mjs';
import { DefaultPool2gb1fm4epwgu9 as DefaultPool } from '../../../../../ktor-ktor-io/io/ktor/utils/io/pool/DefaultPool.mjs';
import { fill2542d4m9l93pn as fill } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isIntArrayeijsubfngq38 as isIntArray } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_IntArrayPool() {
  _init_properties_HttpHeadersMap_kt__hwatby();
  return IntArrayPool;
}
var IntArrayPool;
function get_HeadersDataPool() {
  _init_properties_HttpHeadersMap_kt__hwatby();
  return HeadersDataPool;
}
var HeadersDataPool;
function thresholdReached($this) {
  return $this.size_1 >= $this.headerCapacity_1 * 0.75;
}
function resize($this) {
  var prevSize = $this.size_1;
  var prevData = $this.headersData_1;
  $this.size_1 = 0;
  $this.headerCapacity_1 = imul($this.headerCapacity_1, 2) | 128;
  var tmp = $this;
  // Inline function 'kotlin.apply' call
  var this_0 = get_HeadersDataPool().borrow_mvkpor_k$();
  this_0.prepare_vwo6lb_k$(imul(prevData.arraysCount_qdzoj9_k$(), 2) | 1);
  tmp.headersData_1 = this_0;
  var _iterator__ex2g4s = prevData.headersStarts_9a2v7t_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var headerOffset = _iterator__ex2g4s.next_20eer_k$();
    $this.put_ca69tt_k$(prevData.at_whxqnv_k$(headerOffset + 1 | 0), prevData.at_whxqnv_k$(headerOffset + 2 | 0), prevData.at_whxqnv_k$(headerOffset + 3 | 0), prevData.at_whxqnv_k$(headerOffset + 4 | 0));
  }
  get_HeadersDataPool().recycle_d2xv5h_k$(prevData);
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.require' call
  if (!(prevSize === $this.size_1)) {
    var message = 'Failed requirement.';
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
  }
}
function headerHasName($this, name, headerOffset) {
  var nameStartIndex = $this.headersData_1.at_whxqnv_k$(headerOffset + 1 | 0);
  var nameEndIndex = $this.headersData_1.at_whxqnv_k$(headerOffset + 2 | 0);
  return equalsLowerCase($this.builder_1, nameStartIndex, nameEndIndex, name);
}
var HttpHeadersMapClass;
function HttpHeadersMap() {
  if (HttpHeadersMapClass === VOID) {
    class $ {
      constructor(builder) {
        this.builder_1 = builder;
        this.size_1 = 0;
        this.headerCapacity_1 = 0;
        this.headersData_1 = get_HeadersDataPool().borrow_mvkpor_k$();
      }
      get_6bo4tg_k$(name) {
        if (this.size_1 === 0)
          return null;
        // Inline function 'kotlin.math.absoluteValue' call
        var this_0 = hashCodeLowerCase(name);
        var hash = abs(this_0);
        var headerIndex = hash % this.headerCapacity_1 | 0;
        while (!(this.headersData_1.at_whxqnv_k$(imul(headerIndex, 6) + 0 | 0) === -1)) {
          if (headerHasName(this, name, imul(headerIndex, 6))) {
            return this.valueAtOffset_rvq37j_k$(imul(headerIndex, 6));
          }
          headerIndex = (headerIndex + 1 | 0) % this.headerCapacity_1 | 0;
        }
        return null;
      }
      offsets_plvqo0_k$() {
        return this.headersData_1.headersStarts_9a2v7t_k$();
      }
      put_ca69tt_k$(nameStartIndex, nameEndIndex, valueStartIndex, valueEndIndex) {
        if (thresholdReached(this)) {
          resize(this);
        }
        // Inline function 'kotlin.math.absoluteValue' call
        var this_0 = hashCodeLowerCase(this.builder_1, nameStartIndex, nameEndIndex);
        var hash = abs(this_0);
        var name = this.builder_1.subSequence_hm5hnj_k$(nameStartIndex, nameEndIndex);
        var headerIndex = hash % this.headerCapacity_1 | 0;
        var sameNameHeaderIndex = -1;
        while (!(this.headersData_1.at_whxqnv_k$(imul(headerIndex, 6) + 0 | 0) === -1)) {
          if (headerHasName(this, name, imul(headerIndex, 6))) {
            sameNameHeaderIndex = headerIndex;
          }
          headerIndex = (headerIndex + 1 | 0) % this.headerCapacity_1 | 0;
        }
        var headerOffset = imul(headerIndex, 6);
        this.headersData_1.set_g707pu_k$(headerOffset + 0 | 0, hash);
        this.headersData_1.set_g707pu_k$(headerOffset + 1 | 0, nameStartIndex);
        this.headersData_1.set_g707pu_k$(headerOffset + 2 | 0, nameEndIndex);
        this.headersData_1.set_g707pu_k$(headerOffset + 3 | 0, valueStartIndex);
        this.headersData_1.set_g707pu_k$(headerOffset + 4 | 0, valueEndIndex);
        this.headersData_1.set_g707pu_k$(headerOffset + 5 | 0, -1);
        if (!(sameNameHeaderIndex === -1)) {
          this.headersData_1.set_g707pu_k$(imul(sameNameHeaderIndex, 6) + 5 | 0, headerIndex);
        }
        this.size_1 = this.size_1 + 1 | 0;
      }
      nameAtOffset_nevk7t_k$(headerOffset) {
        var nameStartIndex = this.headersData_1.at_whxqnv_k$(headerOffset + 1 | 0);
        var nameEndIndex = this.headersData_1.at_whxqnv_k$(headerOffset + 2 | 0);
        return this.builder_1.subSequence_hm5hnj_k$(nameStartIndex, nameEndIndex);
      }
      valueAtOffset_rvq37j_k$(headerOffset) {
        var valueStartIndex = this.headersData_1.at_whxqnv_k$(headerOffset + 3 | 0);
        var valueEndIndex = this.headersData_1.at_whxqnv_k$(headerOffset + 4 | 0);
        return this.builder_1.subSequence_hm5hnj_k$(valueStartIndex, valueEndIndex);
      }
      release_wu5yyf_k$() {
        this.size_1 = 0;
        this.headerCapacity_1 = 0;
        get_HeadersDataPool().recycle_d2xv5h_k$(this.headersData_1);
        this.headersData_1 = get_HeadersDataPool().borrow_mvkpor_k$();
      }
      toString() {
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
        dumpTo(this, '', this_0);
        return this_0.toString();
      }
    }
    initMetadataForClass($, 'HttpHeadersMap');
    HttpHeadersMapClass = $;
  }
  return HttpHeadersMapClass;
}
function HeadersData$headersStarts$slambda(this$0) {
  return constructCallableReference(($this$sequence, $completion) => orPromise($completion, function *($completion) {
    var joinedIndex = 0;
    var _iterator__ex2g4s = this$0.arrays_1.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var arr = _iterator__ex2g4s.next_20eer_k$();
      var localIndex = 0;
      while (localIndex < arr.length) {
        if (!(this$0.at_whxqnv_k$(joinedIndex + 0 | 0) === -1)) {
          yield* $this$sequence.yield_3xhcex_k$(joinedIndex, $completion);
        }
        localIndex = localIndex + 6 | 0;
        joinedIndex = joinedIndex + 6 | 0;
      }
    }
    return Unit_instance;
  }), 1);
}
var HeadersDataClass;
function HeadersData() {
  if (HeadersDataClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.arrays_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
      }
      arraysCount_qdzoj9_k$() {
        return this.arrays_1.get_size_woubt6_k$();
      }
      prepare_vwo6lb_k$(subArraysCount) {
        // Inline function 'kotlin.repeat' call
        var inductionVariable = 0;
        if (inductionVariable < subArraysCount)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            this.arrays_1.add_utx5q5_k$(get_IntArrayPool().borrow_mvkpor_k$());
          }
           while (inductionVariable < subArraysCount);
      }
      at_whxqnv_k$(index) {
        return this.arrays_1.get_c1px32_k$(index / 768 | 0)[index % 768 | 0];
      }
      set_g707pu_k$(index, value) {
        this.arrays_1.get_c1px32_k$(index / 768 | 0)[index % 768 | 0] = value;
      }
      headersStarts_9a2v7t_k$() {
        return sequence(HeadersData$headersStarts$slambda(this));
      }
      release_wu5yyf_k$() {
        var _iterator__ex2g4s = this.arrays_1.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var array = _iterator__ex2g4s.next_20eer_k$();
          get_IntArrayPool().recycle_d2xv5h_k$(array);
        }
        this.arrays_1.clear_j9egeb_k$();
      }
    }
    initMetadataForClass($, 'HeadersData', HeadersData);
    HeadersDataClass = $;
  }
  return HeadersDataClass;
}
function dumpTo(_this__u8e3s4, indent, out) {
  _init_properties_HttpHeadersMap_kt__hwatby();
  var _iterator__ex2g4s = _this__u8e3s4.offsets_plvqo0_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var offset = _iterator__ex2g4s.next_20eer_k$();
    out.append_jgojdo_k$(indent);
    out.append_jgojdo_k$(_this__u8e3s4.nameAtOffset_nevk7t_k$(offset));
    out.append_jgojdo_k$(' => ');
    out.append_jgojdo_k$(_this__u8e3s4.valueAtOffset_rvq37j_k$(offset));
    out.append_jgojdo_k$('\n');
  }
}
var IntArrayPool$1Class;
function IntArrayPool$1() {
  if (IntArrayPool$1Class === VOID) {
    class $ extends DefaultPool() {
      constructor() {
        super(1000);
      }
      produceInstance_xswihh_k$() {
        var tmp = 0;
        var tmp_0 = new Int32Array(768);
        while (tmp < 768) {
          tmp_0[tmp] = -1;
          tmp = tmp + 1 | 0;
        }
        return tmp_0;
      }
      clearInstance_c5szmx_k$(instance) {
        fill(instance, -1);
        return protoOf(DefaultPool()).clearInstance_nfz4jw_k$.call(this, instance);
      }
      clearInstance_nfz4jw_k$(instance) {
        return this.clearInstance_c5szmx_k$(isIntArray(instance) ? instance : THROW_CCE());
      }
    }
    initMetadataForClass($);
    IntArrayPool$1Class = $;
  }
  return IntArrayPool$1Class;
}
var HeadersDataPool$1Class;
function HeadersDataPool$1() {
  if (HeadersDataPool$1Class === VOID) {
    class $ extends DefaultPool() {
      constructor() {
        super(1000);
      }
      produceInstance_xswihh_k$() {
        return new (HeadersData())();
      }
      clearInstance_adg7k9_k$(instance) {
        instance.release_wu5yyf_k$();
        return protoOf(DefaultPool()).clearInstance_nfz4jw_k$.call(this, instance);
      }
      clearInstance_nfz4jw_k$(instance) {
        return this.clearInstance_adg7k9_k$(instance instanceof HeadersData() ? instance : THROW_CCE());
      }
    }
    initMetadataForClass($);
    HeadersDataPool$1Class = $;
  }
  return HeadersDataPool$1Class;
}
var properties_initialized_HttpHeadersMap_kt_kotj4w;
function _init_properties_HttpHeadersMap_kt__hwatby() {
  if (!properties_initialized_HttpHeadersMap_kt_kotj4w) {
    properties_initialized_HttpHeadersMap_kt_kotj4w = true;
    IntArrayPool = new (IntArrayPool$1())();
    HeadersDataPool = new (HeadersDataPool$1())();
  }
}
//region block: exports
export {
  HttpHeadersMap as HttpHeadersMapp7szignu4ex,
};
//endregion

//# sourceMappingURL=HttpHeadersMap.mjs.map
